import { ThemeFamilies } from './types';
var getAvatar = function (colors) {
    var _a;
    return (_a = {},
        _a[ThemeFamilies.PRIMARY] = {
            main: colors.secondary,
            text: colors.secondaryText,
        },
        _a[ThemeFamilies.DEFAULT] = {
            main: colors.grey.grey5,
            text: colors.secondaryText
        },
        _a[ThemeFamilies.INFO] = {
            main: colors.surface4,
            text: colors.secondaryText
        },
        _a[ThemeFamilies.SUCCESS] = {
            main: colors.decorative.success,
            text: colors.secondaryText
        },
        _a[ThemeFamilies.WARNING] = {
            main: colors.decorative.warning,
            text: colors.secondaryText
        },
        _a[ThemeFamilies.ERROR] = {
            main: colors.decorative.error,
            text: colors.secondaryText
        },
        _a[ThemeFamilies.DECORATIVE_BLUE] = {
            main: colors.decorative.primary,
            text: colors.secondaryText
        },
        _a[ThemeFamilies.DECORATIVE_PURPLE] = {
            main: colors.primaryHover,
            text: colors.secondaryText
        },
        _a[ThemeFamilies.DECORATIVE_BEIGE] = {
            main: colors.warning,
            text: colors.secondaryText
        },
        _a[ThemeFamilies.DECORATIVE_PINK] = {
            main: colors.errorHover,
            text: colors.secondaryText
        },
        _a[ThemeFamilies.DECORATIVE_TURQUOISE] = {
            main: colors.decorative.infoHover,
            text: colors.secondaryText
        },
        _a);
};
export default getAvatar;
